import history from '../img/History00.png'
import recog from '../img/Recognition71.png'
import gallary from '../img/Gallery00.png'
import media from '../img/Media00.png'
import machine from '../img/machine.jpg'
import pcb from '../img/pcb.jpg'
import iot from '../img/iot.jpg'
import photo from '../img/photo.jpg'
import reels from '../img/reels.jpg'
import movie from '../img/OIP.jpg'
import tech from '../img/tech.jpg'
import tech1 from '../img/tech1.jpg'
import poster from '../img/poster.jpg'
import chess from '../img/chess.jpg'
import paper from '../img/paper.jpg'
import treasure from '../img/treasure.jpg'
import shortfilm from '../img/shortfilm.jpg'
import miniproject from '../img/miniproject.jpeg'
import codersarens from '../img/codersarena.jpeg'
import coders from '../img/coders.jpeg'
import technicalgames from '../img/technicalgames.jpeg'

export const AboutsData=[
    {
     id:'1',
     img:history,
     name:'history',
    
    },
   
    {
     id:'3',
     img:gallary,
     name:'Gallery',
     page:'/gallary',
    },
   
];

export const EventsList=[
    {
      id:'1',
      name:'IOT(Internet Of Things)',
      description:'Explore how digital transformation can create enterprise value and empower worker productivity.',
      img:iot,
      cost:' 1̶2̶5̶0̶  1000',
      date:'24-25 January,2022',
      duration:'12-14 hrs',
      eligibility:'Participants will have to register individually for each workshop.',
      paymentInstr:'While paying the fees, login with the same credentials with which you had registered on the Eclatecs Website. Please enter the data correctly for us to process your payment information properly.',
      prerequisites:' A laptop/PC with Microsoft Windows (7 or later & Minimum 4GB RAM), configuration Internet Connectivity (Typically to be able to do video call / conferencing), Notepad & Pen.',
      certificate:'Participants should be present in all the sessions. Failing this, no certificate will be awarded to the participant. Certificate of Training from Eclatecs, JNTUA kalikiri will be given to all the participants.',
      note:'No Refunds will be entertained after 30th November 2021. **Limited number of seats** If the Workshop gets cancelled, all the participants will be given full refund, irrespective of the Deadline.',
      person:'Y.Vandana,P.Naveen',
      mail:'eclatecs2k22@gmail.com',
      contact :'9381673137 , 9381167782 , 8374705933',
      explore:'/explore1',
      register:'https://rzp.io/l/EgiIFmp',
      register1:'',
    },
    {
      id:'2',
      name:'Machine Learning with Python',
      description:'Machine learning is a type of artificial intelligence(AI) that provides computer with the ability to learn without being explicity programmed. Machine learning focuses on the development of computer programs that can change when exposed to new data . ',
      img:machine,
      cost:' 1̶3̶5̶0̶  1000',
      date:'24-25 January,2022',
      duration:'12-14 hrs',
      eligibility:'Participants will have to register individually for each workshop.',
      paymentInstr:'While paying the fees, login with the same credentials with which you had registered on the Eclatecs Website. Please enter the data correctly for us to process your payment information properly.',
      prerequisites:' A laptop/PC with Microsoft Windows (7 or later & Minimum 4GB RAM), configuration Internet Connectivity (Typically to be able to do video call / conferencing), Notepad & Pen.',
      certificate:'Participants should be present in all the sessions. Failing this, no certificate will be awarded to the participant. Certificate of Training from Eclatecs, JNTUA kalikiri will be given to all the participants.',
      note:'No Refunds will be entertained after 30th November 2021. **Limited number of seats** If the Workshop gets cancelled, all the participants will be given full refund, irrespective of the Deadline.',
      person:' J.Hari Krishna, U.Sudha Rani',
      mail:'eclatecs2k22@gmail.com',
      contact :'9381673137 , 9381167782 , 8374705933',
      explore:'/explore2',
      register:'https://rzp.io/l/KZDZY1o1K4',
      register1:'',
    },
    {
      id:'2',
      name:'PCB (Printed Circuit Board) Design',
      description:'PCB is a acronym of printed circuit board that helps in connecting the electronics components with pads,tracks and lines incorporated on a laminated copper sheet.  ',
      img:pcb,
      cost:'    ̶9̶5̶0̶  750',
      date:'24-25 January,2022',
      duration:'12-14 hrs',
      eligibility:'Participants will have to register individually for each workshop.',
      paymentInstr:'While paying the fees, login with the same credentials with which you had registered on the Eclatecs Website. Please enter the data correctly for us to process your payment information properly.',
      prerequisites:' A laptop/PC with Microsoft Windows (7 or later & Minimum 4GB RAM), configuration Internet Connectivity (Typically to be able to do video call / conferencing), Notepad & Pen.',
      certificate:'Participants should be present in all the sessions. Failing this, no certificate will be awarded to the participant. Certificate of Training from Eclatecs, JNTUA kalikiri will be given to all the participants.',
      note:'No Refunds will be entertained after 30th November 2021. **Limited number of seats** If the Workshop gets cancelled, all the participants will be given full refund, irrespective of the Deadline.',
      person:'B.Venkateswarlu, S.Shaira Bhanu',
      mail:'eclatecs2k22@gmail.com',
      contact :'9381673137 , 9381167782 , 8374705933',
      explore:'/explore3',
      register:'https://rzp.io/l/tYeChM3G2',
      register1:'',
    },

   
 
];

export const EventsPageList=[
 
  {
    id:'1',
    name:'Treasure Hunt',
    description:'It is a game in which the team attempts to be first in finding the treasure that has been hidden , using written directions or dues.The game gives more fun while decoding the clues,improves the Teamspirit.',
    img:treasure,
    cost:'350',
    date:'23 December,2021',
   date1:'----------------------',
    date2:'25 January,2022',
    first:`Encourages creativity & thinking out of the box. Treaure Hunt is incredibly funny (By peronalising an event from your chosen venue with custom clues,treasure hunt is great for laughing. Encourages leadership,teamwork, communication and interaction. The flexibility in terms of the chosen clues,locations and prizes of the event means that the "message" or objective of a treasure hunt event can conveyed to teams in a engaging fashion.`,
    one:'1. The team must have 5 members.',
    two:'2. Spot registrations are available.',
    three:'3. No Refunds will be entertained. **Limited number of seats** If the event gets cancelled, all the participants will be given full refund, irrespective of the Deadline.',
    four:'',
    person:'V. Chandan, N.Archana',
    mail:'eclatecs2k22@gmail.com',
    contact :'9381673137 , 9381167782 , 8374705933',
    explore:'/exploreevents1',
    register:'https://rzp.io/l/UYeAmfSzbc',
    register1:'/treasurehunt.pdf',
  },
  {
    id:'2',
    name:'Reels Contest',
    description:'Reels are short, entertaining videos on instagram where you can express your brand to life. People come to Reels to participate in cultural trends,collaborate with the community and discover new ideas. ',
    img:reels,
    cost:'100',
    date:'19 January,2022',
    date1:'',
    date2:'24 January,2022',
    first:'It helps us to improve our acting skills. It include lots of fun and entertainment. It encourages creativity. It is a highly recommended platform to get famous in very short time. It increases connectivity with the followers.',
    one:'',
    two:'',
    three:'1. One member is allowed to participate in only one reel.',
    four:'2. No Refunds will be entertained. **Limited number of seats** If the event gets cancelled, all the participants will be given full refund, irrespective of the Deadline.',
    person:'CH.Meghana Priya, K.Siva Krishna',
    mail:'eclatecs2k22@gmail.com',
    contact :'9381673137 , 9381167782 , 8374705933',
    explore:'/exploreevents2',
    register:'https://rzp.io/l/scq2qfZ',
    register1:'',
  },
  {
    id:'3',
    name:'Short Film',
    description:'A Short Film is any motion picture that is short enough in running time not to be considered to be feature film. Short films are often screened at local,national or international film festivals and made by independent film makers with either a low budget or no budget at all.',
    img:shortfilm,
    cost:'150',
    date:'23 December,2021',
    date1:'20 January,2022',
    date2:'25 January,2022',
    first:'Theme : Film should be humourous, ethical and useful to society. It is a platform to secure future funding projects.Shortfilm is also being used in modern times to showcase technology such as CGI. It offers the possibility of social awareness of issues in society. Short Films are important for audiences because they are simple forms of entertainment.',
    one:'',
    two:'',
    three:' Note: Prize money will be decided depending upon the number of registrations.',
    four:'1. No Refunds will be entertained. **Limited number of seats** If the event gets cancelled, all the participants will be given full refund, irrespective of the Deadline.',
    person:'B.Prem Kumar, S.Shamshad',
    mail:'eclatecs2k22@gmail.com',
    contact :'9381673137 , 9381167782 , 8374705933',
    explore:'/exploreevents3',
    register:'https://rzp.io/l/6GE2DaA',
    register1:'/shortfilmcompetition.pdf',
  },
 
  {
    id:'4',
    name:'Non-Technical Quiz',
    description:'Bring up the right mix of entertainer and enterprenuer in you onto the stage. We give you a product and you give it a marketing blend alluring your customers.',
    img:tech1,
    cost:'100',
    date:'23 December,2021',
    date1:'--------------------',
    date2:'25 January,2022',
    first:'It is an opportunity to demonstrate the knowledge of a student.We can gain overall knowledge not only subjects that we learn in college. It tests your knowledge what we know about our society. Increases self-confidence.',
    one:'1. Only one person can participate. There will be only one round .',
    two:'2. The quiz will be of one hour duration.There are a total of 60 questions.',
    four:'3. No Refunds will be entertained. **Limited number of seats** If the event gets cancelled, all the participants will be given full refund, irrespective of the Deadline.',
    three:'Note: Prize money will be decided depending upon the number of registrations.',
    person:'R.Madhu Naik, D.Bhavana',
    mail:'eclatecs2k22@gmail.com',
    contact :'9381673137 , 9381167782 , 8374705933',
    explore:'/exploreevents4',
    register:'https://rzp.io/l/VTYiTmmw',
    register1:'/nontechnicalquiz.pdf',
  },
  {
    id:'5',
    name:'Photography Contest',
    description:'It is a art of capturing moment with a camera or mobile. Usually via digital sensor or film,to create an image. It is a practice of creating durable images.',
    img:photo,
    cost:'100',
    date:'19 December,2021',
    date1:'24 January,2022',
    date2:'25 January,2022',
    first:'It helps you to capture anything which you feel important to remember. It helps you find beauty in the world. Photography preserves new and old memories. It is a wonderful stress reliever. Photography inspires your imagination.',
    one:'1. No Refunds will be entertained. **Limited number of seats** If the event gets cancelled, all the participants will be given full refund, irrespective of the Deadline.',
    two:'Note: Prize money will be decided depending upon the number of registrations.',
    four:'',
    three:'',
    person:'J.Chetan , O. Keerthi ',
    mail:'eclatecs2k22@gmail.com',
    contact :'9381673137 , 9381167782 , 8374705933',
    explore:'/exploreevents5',
    register:'https://rzp.io/l/mz95Gi58G',
    register1:'',
  },
  {
    id:'10',
    name:'Movie Quiz',
    description:'This is a collection of trivia and personality quizzes for people who are serious movie lovers-in one place for your convinience.It`s time to test your movie knowledge. Note: We need atleast five teams to get registered to conduct this event.',
    img:movie,
    cost:'50',
    date:'23 December,2021',
   date1:'-----------------------------',
    date2:'25 January,2022',
    first:'It is exactly what it sounds like" An evening of trivia for every kind of film fan. Films can drive social change due to their ability to teach viewers about experiences outside our own prespective. It is fun to enjoy the movie quiz with friends. We can gain some knowledge from movies,useful to our day to day life.',
    one:'1. A team must contain maximum of three members.',
    two:'2. A participant can participate only once.',
    three:'3. Any kind of malpractice during the time of event leads to disqualification. ',
    four:'4. No Refunds will be entertained. **Limited number of seats** If the event gets cancelled, all the participants will be given full refund, irrespective of the Deadline.',
    person:'C. Shilpa , A. Hari Krishna ',
    mail:'eclatecs2k22@gmail.com',
    contact :'9381673137 , 9381167782 , 8374705933',
    explore:'/exploreevents14',
    register:'https://rzp.io/l/iqLLvEKh0',
    register1:'/movie.pdf',
    
  },
  {
    id:'11',
    name:'Chess Master Tournament',
    description:'The modern chadaranga is an event at eclatecs 2k22 where an individual will get an opportunity to defeat his co-players and stand as the chess master of the symposium and get the prize money.',
    img:chess,
    cost:'100',
    date:'23 December,2021',
   date1:'-----------------------------',
    date2:'25 January,2022',
    first:'',
    one:'1. No of rounds and prize money will be decided based on the no.of registrations.',
    two:'2. A participant can participate only once.',
    three:'3. Any kind of malpractice during the time of event leads to disqualification. ',
    four:'4. No Refunds will be entertained. **Limited number of seats** If the event gets cancelled, all the participants will be given full refund, irrespective of the Deadline.',
    person:'J. Tharun Balaji, S. Padmini ',
    mail:'eclatecs2k22@gmail.com',
    contact :'9381673137 , 9381167782 , 8374705933',
    explore:'/exploreevents15',
    register:'https://rzp.io/l/rAjwfbbC',
    register1:'/chessmastertournament.pdf',
    
  },
 
 
];

export const TechnicalEvents=[
  {
    id:'7',
    name:'Paper Presentation',
    description:'Paper presentation is an individual competition where each participant is required to prepare a presentation about a given topic or area and then present it infront of the juries.To enhance the ability of participants in writing and presenting papers in english . ',
    img:paper,
    cost:'200',
    date:'23 December,2021',
   date1:'20 January,2022',
    date2:'25 January,2022',
    first:'It helps in creating innovative ideas.Students come up with creative and interesting slides to illustrate their talk. It provides an opportunity to learn and develop effective presentation skills. It helps in improving communication skills, grow leadership and influence. It aid readers in sustaining their intrest.   *Note*:Topics are mentioned in the content.',
    one:'1.The team must have 2 members.Spot registrations are available.',
    two:'2.Candidates must carry their pendrives for their presentation.The teams will get 5 minutes to present the paper and 2 minutes will be for questioning by Judges. ',
    three:'3.Two hard copies have to be submitted to the judge at the time of presentation.The paper should be in IEEE format.Abstract should not exceed the limit of two pages. ',
    four:'4.No Refunds will be entertained. **Limited number of seats** If the event gets cancelled, all the participants will be given full refund, irrespective of the Deadline.',
    person:'A. Yamini , G. Bharath',
    mail:'eclatecs2k22@gmail.com',
    contact :'9381673137 , 9381167782 , 8374705933',
    explore:'/exploreevents6',
    register:'https://rzp.io/l/22WrWEhPc',
    register1:'/paperpresentation.pdf',
  },
  {
    id:'8',
    name:'Poster Presentation',
    description:'Poster presentation is a way to communicate your research or your understanding of a topic in a short and concise format including two elements, a poster and a brief explanation.',
    img:poster,
    cost:'200',
    date:'23 December,2021',
   date1:'20 January,2022',
    date2:'25 January,2022',
    first:'A Poster Presentation provides a visual representation of your research through text,charts,graphs and other visual aids. Poster Presentation develop your ability to communicate perceptively and concisely.The motto of poster presentation is to overcome the stage fear. It helps to improve communication skills.   *Note*:Topics are mentioned in the content.',
    one:'1. Students are requested to carry the copies of relevant papers on hand as well as copies of posters on standard sized paper (A3).',
    two:'2. Individuals are only allowed to participate(No teams are allowed).',
    three:'3. No Refunds will be entertained. **Limited number of seats** If the event gets cancelled, all the participants will be given full refund, irrespective of the Deadline. ',
    four:'',
    person:'G. Ravi , T. Vandana',
    mail:'eclatecs2k22@gmail.com',
    contact :'9381673137 , 9381167782 , 8374705933',
    explore:'/exploreevents7',
    register:'https://rzp.io/l/7gf4AqBi69',
    register1:'/posterpresentation.pdf',
  },
  {
    id:'9',
    name:'Technical Quiz',
    description:`A quiz is a game which can also be called " Mind Sport " where players either as an individual or in teams attempt to answer questions, posed to them correctly,In order to win a prize.`,
    img:tech,
    cost:'100',
    date:'23 December,2021',
   date1:'----------',
    date2:'25 January,2022',
    first:'It is a "Mind Sport" where the players attempt to answer questions posed to them correctly,in order to win a prize. It gives an opportunity to demonstrate knowledge of the student. We can gain more confidence while answering a question. It helps student to learn with practice as it allows the students to think back the topics previously learned. It helps us to know what we did wrong immediately. ',
    one:'1. Team size: Maximum 5',
    two:'2. Any kind of malpractice during the time of event leads to disqualification.',
    three:'3. ECLATECS team decision is final. ',
    four:'4. No Refunds will be entertained. **Limited number of seats** If the event gets cancelled, all the participants will be given full refund, irrespective of the Deadline.',
    person:'S. Spandana , P. Navya Nadh ',
    mail:'eclatecs2k22@gmail.com',
    contact :'9381673137 , 9381167782 , 8374705933',
    explore:'/exploreevents8',
    register:'https://rzp.io/l/DWhV4QV',
    register1:'/technicalquiz.pdf',
  },
 
  {
    id:'11',
    name:'Circuit Fixer',
    description:'It is a event which tests the speed of electronics engineers in analysing gates. It improves analytical knowledge and speed of a participant.',
    img:codersarens,
    cost:'100',
    date:'23 December,2021',
   date1:'------------------------',
    date2:'25 January,2022',
    first:'It gives the knowledge of Digital Electronics. It helps in understanding latest technology.This electronix leads you to the fastest circuit maker. You will be the Electronix puzzle solver.',
    one:'1. A participant can participate only once.',
    two:'2. Individuals are only allowed to participate(No teams are allowed).',
    three:'3. No Refunds will be entertained. **Limited number of seats** If the event gets cancelled, all the participants will be given full refund, irrespective of the Deadline. ',
    four:'',
    person:'S. Preethi , G. Vinay Gowd ',
    mail:'eclatecs2k22@gmail.com',
    contact :'9381673137 , 9381167782 , 8374705933',
    explore:'/exploreevents9',
    register:'https://rzp.io/l/3CD0ybfu',
    register1:'',
  },
  {
    id:'12',
    name:'Mini Project',
    description:'It helps you explore and strengthen the understanding of fundamentals through practical application of theoritical concepts. ',
    img:miniproject,
    cost:'400',
    date:'23 December,2021',
   date1:'------------------------',
    date2:'25 January,2022',
    first:' Mini Projects helps you to explore and strengten the understanding of fundamentals through practical application of theoritical concepts. It can help you to boost your skills and broaden your horizon of thinking. It acts like a beginners guide to do larger projects later in their carrier. It provides opportunities for expansion of knowledge and skills and broaden learning experience.',
    one:'1. Students should have to present and explain about their project in the expo.',
    two:'2. We will also display and make a clear picture of our projects.',
    three:'3. Students those who are presenting their projects have to bring their required materials. NO accomodation is provided.',
    four:'4. No Refunds will be entertained. **Limited number of seats** If the event gets cancelled, all the participants will be given full refund, irrespective of the Deadline. ',
    person:'L.Sravanthi, G.V. Sujith ',
    mail:'eclatecs2k22@gmail.com',
    contact :'9381673137 , 9381167782 , 8374705933',
    explore:'/exploreevents10',
    register:'https://rzp.io/l/cBoe5Pou0',
    register1:'/miniproject.pdf',
  },
  {
    id:'13',
    name:'Technical Games',
    description:' List of all the technical games is provided in content. please go through it. ',
    img:technicalgames,
    cost:'100',
    date:'23 December,2021',
   date1:'------------------------',
    date2:'25 January,2022',
    first:'It helps us to improve Attention and Concentration. It improves the brain speed. It can teach you to be a better problem solver. It increases memory capacity.Technical games improves team coordination and relief stress. It improves our knowledge and thinking capacity. ',
    one:'1. No Refunds will be entertained. **Limited number of seats** If the event gets cancelled, all the participants will be given full refund, irrespective of the Deadline.  ',
    two:' ',
    three:'',
    four:'',
    person:'P. Likitha sree, N.Uday Kumar  ',
    mail:'eclatecs2k22@gmail.com',
    contact :'9381673137 , 9381167782 , 8374705933',
    explore:'/exploreevents11',
    register:'https://rzp.io/l/ThWHy0Ocd ',
    register1:'/Technicalgames.pdf',
  },
  {
    id:'14',
    name:'Coders Arena',
    description:' We provide you a question and you need to solve it with your coding skills. Your solution Should not contaain any errors and you should complete within the given time. ',
    img:coders,
    cost:'100',
    date:'23 December,2021',
   date1:'------------------------',
    date2:'25 January,2022',
    first:'Coding ability gives new perspective to problem solving. Demand remains strong for coding-related jobs. It will teach you how to think logicaly and how to translate logical thinking into a computer language. Coding makes you innovative. ',
    one:'1. No Refunds will be entertained. **Limited number of seats** If the event gets cancelled, all the participants will be given full refund, irrespective of the Deadline.  ',
    two:'Note : System with software is provided by us. Software that you can use are C, Python, MATLAB .',
    three:'',
    four:'',
    person:' P. Likitha sree, N.Uday Kumar  ',
    mail:'eclatecs2k22@gmail.com',
    contact :'9381673137 , 9381167782 , 8374705933',
    explore:'/exploreevents12',
    register:'https://rzp.io/l/lSinJRlJgt ',
    register1:'/codersarena.pdf',
  },
];

export const ContactNames=[
  {
    id:'1',
    heading:'CHIEF PATRON',
    person1:'Prof.G.Ranga Janardhana',
    person2:'Hon`ble Vice-Chancellor, JNTU Anantapur',
  },
  {
    id:'2',
    heading:'PATRON',
    person1:'Prof.C.Sasidhar',
    person2:'Registrar, JNTU Anantapur',
  },
  {
    id:'3',
    heading:'CO-PATRON',
    person1:'Prof.M.L.S.Deva Kumar ',
    person2:'Principal, JNTUACEK.',
  },
  {
    id:'4',
    heading:'Convenor',
    person1:'Prof.C.Subhas ',
    person2:'Vice Principal & HECED, JNTUACEK.',
  },
  {
    id:'5',
    heading:'Program Coordinator',
    person1:'Dr.K.Aparna ',
    person2:'Asst.Professor, JNTUACEK',
  },
  {
    id:'6',
    heading:'Staff Coordinators',
    person1:'Mrs.M.Revathy ',
    person2:'Mrs.U.Sudha Rani',
  },
  {
    id:'7',
    heading:'Organising Committee',
    person1:'Mr.T.Durga Rao ',
    person2:'Mrs.K.Ganga Bhavani',
    person3:'Mrs.K.Hema Vani',
  },
  {
    id:'8',
    heading:'Student Coordinators',
    person1:'D.C.Sampath Raj --- phn: 9381673137',
    person2:'S.Rithika --- phn:9381167782',
  },
]